import { useMemo } from "react";

/**
 * GitHub-style 90-day workout activity heatmap.
 * Renders a 13-column × 7-row grid (Sunday top → Saturday bottom).
 * Cells colored by intensity (0-4).
 */
export default function Heatmap({ data = [] }) {
  const grid = useMemo(() => {
    if (!data?.length) return [];
    // Place items into weekly columns. The last day of `data` is "today" (rightmost column, bottom-most weekday).
    const rev = [...data].reverse(); // newest first
    const today = new Date(rev[0].date + "T00:00:00Z");
    const todayDow = today.getUTCDay(); // 0..6 (Sun..Sat)

    // We want 13 columns. Latest column has rows for weekdays from Sun..todayDow.
    const totalCells = 13 * 7;
    const cells = new Array(totalCells).fill(null);

    // We'll iterate over each day going back from today.
    // Map (column, row) -> cells[col + row*13]
    let colsBack = 0;
    let dow = todayDow;
    rev.forEach((item) => {
      const col = 12 - colsBack;
      const row = dow;
      if (col >= 0) {
        cells[col + row * 13] = item;
      }
      // step back one day
      if (dow === 0) {
        dow = 6;
        colsBack += 1;
      } else {
        dow -= 1;
      }
    });
    return cells;
  }, [data]);

  return (
    <div className="grid grid-cols-13 gap-1" data-testid="workout-heatmap" style={{ gridTemplateColumns: "repeat(13, minmax(0, 1fr))" }}>
      {Array.from({ length: 7 }, (_, row) => (
        <div key={row} className="contents">
          {Array.from({ length: 13 }, (_, col) => {
            const cell = grid[col + row * 13];
            const cls = cell?.active ? "hm-3" : "hm-0";
            return (
              <div
                key={`${col}-${row}`}
                className={`aspect-square rounded-[3px] ${cls}`}
                title={cell?.date || ""}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
